
<div class="confirm-modal-container">
  <h2 mat-dialog-title>{{data.title}}</h2>
  <mat-dialog-content>
    <div class="modal-body">
      <div class="row">
        <div class="col-lg-12">
          <p [innerHTML]="data.message"></p>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions >

    <div class="d-flex justify-content-end gap-2 w-100 mb-2 pe-3">
      <button mat-raised-button color="primary" (click)="confirm()">Yes</button>
      <button mat-raised-button color="warn" (click)="decline()">No</button>
    </div>
  </mat-dialog-actions>
</div>
 